import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.checkTicket || initialState;

export const selectCheckTicket = createSelector(
  [selectSlice], state => state);

export const selectIsLoading = createSelector(
  [selectCheckTicket],
  state => state.loading,
);

export const selectIsError = createSelector(
  [selectCheckTicket],
  state => state.error,
);

export const selectIsSuccess = createSelector(
  [selectCheckTicket],
  state => state.success,
);

export const selectListTicket = createSelector(
  [selectCheckTicket],
  state => state.listTicket,
);
export const selectPaginator = createSelector(
  [selectCheckTicket],
  state => state.paginator,
);

export const selectNotFound = createSelector(
  [selectCheckTicket],
  state => state.errorNotFound,
);
export const selectGetListPaymentMethods = createSelector(
  [selectCheckTicket],
  state => state.listPaymentMethod,
);

export const selectMaxFileReleaseTicket = createSelector(
  [selectCheckTicket],
  state => state.maxFileReleaseTicket,
);